import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { AppserviceService } from 'src/app/appservice.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {
  AppData$;
  adminBool:boolean = false;
  @Input() public adminUBool;
  constructor(private route: ActivatedRoute, private router: Router, private AppService :AppserviceService) { 
    this.adminBool = (localStorage.getItem('admin') === '1')?true:false;
  }

  openPage(page){
    this.router.navigate(['/' + page]);
  }

  ngOnInit() {
  }
}
